import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'

/** What a select-all may toggle: whatever is selected, and whatever is not disabled. */
export function filterSelectable(
  items: readonly IResourceRecord[],
  selectedIds: ReadonlySet<string>,
  isItemDisabled?: (recordId: string) => boolean,
): IResourceRecord[] {
  return items.filter(
    item => selectedIds.has(item.id) || !isItemDisabled?.(item.id),
  )
}
